import Button from '@mui/material/Button';
import { func } from 'prop-types';
import sty from '../styles/Buttons.module.css';

/**
 * @component SubTabButtons
 * @param { Object } props
 * @param { function } props.onSave
 * @param { function } props.onReset
 * @returns { JSX.Element }
 */
function SubTabButtons({ onSave, onReset }) {
	return (
		<section className={sty.buttons}>
			<Button className={sty.button} variant="outlined" size="small" color="sds" onClick={onSave}>
				SAVE
			</Button>
			<Button className={sty.button} variant="outlined" size="small" color="sds" onClick={onReset}>
				RESET
			</Button>
		</section>
	);
}

SubTabButtons.propTypes = {
	onSave: func,
	onReset: func,
};

export default SubTabButtons;
